import { render, staticRenderFns } from "./grid-header-banner.vue?vue&type=template&id=3fd04452&scoped=true"
import script from "./grid-header-banner.vue?vue&type=script&lang=js"
export * from "./grid-header-banner.vue?vue&type=script&lang=js"
import style0 from "./grid-header-banner.vue?vue&type=style&index=0&id=3fd04452&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd04452",
  null
  
)

export default component.exports